import React from 'react';
import '../Assets/css/footer.css'; // Asegúrate de tener un archivo CSS para estilos
import bannerGroup from '../Assets/img/barralogos.png'; // Asegúrate de tener una imagen para mostrar
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebook, faInstagram } from '@fortawesome/free-brands-svg-icons';
export const Footer = () => {
    return (
        <footer className="footer" id="contacto">
            <h1>Contacto</h1>
            <div className="contact-info">
                <div className="contact-item">
                    <h4>Oscar Fuenzalida Romero</h4>
                    <p>Coordinador de Operaciones de Travel Pluss</p>
                    <p>2 2381 3529 | +569 3195 0429</p>
                    <p className="email">operaciones@travelpluss.cl</p>
                </div>

            </div>
            <div className="footer-logos">
                <img src={bannerGroup} alt="Plus Chile"/>

            </div>
            <div className="social-icons">
                <a href="https://www.facebook.com/TravelPussChile" target="_blank" rel="noopener noreferrer">
                    <FontAwesomeIcon icon={faFacebook} size="2x" color="white"/>
                </a>
                <a href="https://www.instagram.com/travelplusschile/" target="_blank" rel="noopener noreferrer">
                    <FontAwesomeIcon icon={faInstagram} size="2x" color="white"/>
                </a>
            </div>

            <p className="footer-text">Todos los derechos reservados Travel Pluss | Desarrollado por Grupo Pluss
                Chile</p>
        </footer>
    );
}


